export enum TSKulturart {
    WIESEWEIDE = <any> 'WIESEWEIDE',
    ACKERLAND = <any> 'ACKERLAND',
    ANDERE = <any> 'ANDERE'
}

export function getTSKulturartValues(): Array<TSKulturart> {
    return [
        TSKulturart.WIESEWEIDE,
        TSKulturart.ACKERLAND,
        TSKulturart.ANDERE
    ];
}

export function kulturartPrefix(): string {
    return 'TSKulturart_';
}



// WEBPACK FOOTER //
// ./src/app/models/enums/TSKulturart.ts